import { logFirebaseEvent } from "services/analytics/firebase";
import { logMixpanelEvent } from "services/analytics/mixpanel";
import { logDebugEvent } from "config/debugEventsView";
import { DEBUG_EVENTS_ENABLED } from "utils/constants";
import events from "./constants";

function eventPageTransalation(url: string) {
  return events.pages[url];
}
class EventNameTooLongError extends Error {}
export interface EventParams {
  [key: string]: string | number | undefined;
}

export function logEvent(
  eventName: string,
  eventParams: EventParams = {},
): void {
  const convertedParams = eventParams;
  convertedParams.anonymousId =
    localStorage.getItem("installationId") ?? "false";
  convertedParams.integrationName =
    localStorage.getItem("integrationName") ?? "false";
  convertedParams.hasDonated = localStorage.getItem("HAS_DONATED") ?? "false";
  convertedParams.platform = "web";

  if (eventName.length > 32) {
    throw new EventNameTooLongError();
  } else if (process.env.NODE_ENV === "production") {
    logFirebaseEvent(eventName, convertedParams);
    logMixpanelEvent(eventName, convertedParams);
  }
  if (DEBUG_EVENTS_ENABLED && logDebugEvent) {
    logDebugEvent(eventName, convertedParams);
  }
}

export function logPageView(
  urlName: string,
  search?: string,
  state?: any,
): void {
  let flow = "";
  let query = "";
  const params: any = {};
  if (state) {
    flow = state.flow ? `?${state.flow}` : "";
    if (state.cause?.id) {
      params.causeId = state.cause.id;
    }
    if (state.nonProfit?.id) {
      params.nonProfitId = state.nonProfit.id;
    }
  }
  if (urlName.includes("promoter") && search?.includes("payment_method=card")) {
    query = "?payment_method=card";
  }

  const pageName = eventPageTransalation(urlName + query + flow);

  if (pageName) {
    logEvent(`${pageName}_view`, params);
  }
}
